import {
  AlertTriangle,
  BarChart3,
  GalleryHorizontalEnd,
  IdCard,
  LineChart,
  ScatterChart,
  Boxes,
  ChartPie,
  Coins,
  CreditCard,
  Filter,
  Gauge,
  Grid3x3,
  LayoutList,
  List,
  Map,
  Rss,
  Share2,
  Sigma,
  Sparkle,
  Sparkles,
  Table2,
  TrendingUp,
  Wallet,
} from 'lucide-react';

/**
 * Widget type → row icon and its `iconHighlight` tint (CT-5187).
 *
 * One map, so no component ever branches per type in JSX. Every tint is passed
 * as both `bgColor` and `iconColor`, so it must be a name `IconHighlight`
 * accepts in *both* token maps — never a colour literal. An unknown name is not
 * an error there: it is handed straight to CSS, which paints the icon the same
 * colour as its own background and hides it.
 */
const WIDGET_TYPE_ICONS = {
  kpi: { icon: TrendingUp, highlight: 'LightBlue' },
  stat_row: { icon: LayoutList, highlight: 'LightBlue' },
  gauge: { icon: Gauge, highlight: 'Purple' },
  chart: { icon: BarChart3, highlight: 'Primary' },
  // The builder splits `chart` into line and bar and offers three types the
  // seeded catalog never used (CT-5196). Catalog rows and the detail panel must
  // still render a widget saved under any of them.
  line_chart: { icon: LineChart, highlight: 'Primary' },
  bar_chart: { icon: BarChart3, highlight: 'Primary' },
  correlation: { icon: ScatterChart, highlight: 'Orange' },
  pie: { icon: ChartPie, highlight: 'Purple' },
  area: { icon: TrendingUp, highlight: 'Primary' },
  stacked_bar: { icon: BarChart3, highlight: 'Primary' },
  sparkline: { icon: TrendingUp, highlight: 'LightBlue' },
  profile_card: { icon: IdCard, highlight: 'LightBlue' },
  carousel: { icon: GalleryHorizontalEnd, highlight: 'LightBlue' },
  donut: { icon: ChartPie, highlight: 'Purple' },
  funnel: { icon: Filter, highlight: 'Alert' },
  heat_map: { icon: Grid3x3, highlight: 'Alert' },
  map: { icon: Map, highlight: 'Success' },
  ai_summary: { icon: Sparkles, highlight: 'Purple' },
  // Added alongside widgetTypes.js in CT-5196 (a7e1660) — must stay in sync
  // with that registry, since this is a second, independent map.
  next_best_action: { icon: Sparkle, highlight: 'Purple' },
  table: { icon: Table2, highlight: 'Primary' },
  list: { icon: List, highlight: 'Primary' },
  connections: { icon: Share2, highlight: 'LightBlue' },
  board: { icon: Boxes, highlight: 'LightBlue' },
  feed: { icon: Rss, highlight: 'Success' },
  alerts: { icon: AlertTriangle, highlight: 'Alert' },
  cost_kpi: { icon: Coins, highlight: 'Yellow' },
  usage_heatmap: { icon: Grid3x3, highlight: 'Yellow' },
  spend_breakdown: { icon: Wallet, highlight: 'Yellow' },
  composite_stat: { icon: Sigma, highlight: 'LightBlue' },
};

const FALLBACK = { icon: CreditCard, highlight: 'Primary' };

/** Never returns undefined: an unmapped type still renders a recognisable row. */
export const widgetTypeIcon = (type) => WIDGET_TYPE_ICONS[type] ?? FALLBACK;
